import request from '@/utils/request'

export function adminGetGameScore(gameId) {
  const params = {
    id: gameId
  }
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetGameScore.json',
    method: 'get',
    params
  })
}

// 射中管理
export function adminAddGameGoalEvent(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminAddGameGoalEvent.json',
    method: 'post',
    data
  })
}

export function adminUpdateGameScore(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminUpdateGameScore.json',
    method: 'post',
    data
  })
}

export function adminUpdateGameGoalEvents(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminUpdateGameGoalEvents.json',
    method: 'post',
    data
  })
}

export function adminUpdateGameGoalEvent(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminUpdateGameGoalEvent.json',
    method: 'post',
    data
  })
}

export function adminDeleteGameGoalEvents(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminDeleteGameGoalEvents.json',
    method: 'post',
    data
  })
}

// 判罚管理
export function adminAddGamePenaltyEvent(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminAddGamePenaltyEvent.json',
    method: 'post',
    data
  })
}

export function adminUpdateGamePenaltyEvents(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminUpdateGamePenaltyEvents.json',
    method: 'post',
    data
  })
}

export function adminUpdateGamePenaltyEvent(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminUpdateGamePenaltyEvent.json',
    method: 'post',
    data
  })
}

export function adminDeleteGamePenaltyEvents(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminDeleteGamePenaltyEvents.json',
    method: 'post',
    data
  })
}

// 射门管理
export function adminAddGameShootoutEvent(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminAddGameShootoutEvent.json',
    method: 'post',
    data
  })
}

export function adminUpdateGameShootoutEvents(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminUpdateGameShootoutEvents.json',
    method: 'post',
    data
  })
}

export function adminUpdateGameShootoutEvent(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminUpdateGameShootoutEvent.json',
    method: 'post',
    data
  })
}

export function adminDeleteGameShootoutEvents(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminDeleteGameShootoutEvents.json',
    method: 'post',
    data
  })
}

export function adminUpdateGameOffice(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminUpdateGameOffice.json',
    method: 'post',
    data
  })
}
export function AdminUpdateOutGameOffice(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminUpdateOutGameOffice.json',
    method: 'post',
    data
  })
}

export function exportGameData(gameId) {
  const params = {
    gameId: gameId
  }
  return request({
    url: process.env.BJH_API + '/api/content/pc/ExportGameData.json',
    method: 'get',
    params
  })
}
